import { useTrust } from '../../query/trusts';
import { errorToast } from '../../utils/toast';
import { LOGIN_URL } from '../../routes/AppRoutes';
import { useAuth } from '../../context/AuthContext';
import { useCommonTranslation } from '../i18n/useCommonTranslation';
import { useHistory } from 'react-router';
import { useCallback, useMemo } from 'react';
import { SAMLAuthProvider } from 'firebase/auth';

const SSO_PROVIDER_TYPE_SAML = 'saml';

export const useTrustSSOLogin = ({ trustId }: { trustId: string }) => {
  const { t } = useCommonTranslation();
  const { replace } = useHistory();

  const { loginWithProvider } = useAuth();
  const { isLoading, data: trust } = useTrust(trustId, {
    onSuccess: (trustData) => {
      if (!trustData?.sso_provider_id) {
        errorToast(t('sso-configuration-not-found'));
        replace(LOGIN_URL);
      } else if (trustData?.sso_provider_type !== SSO_PROVIDER_TYPE_SAML) {
        errorToast(t('sso-configuration-unknown-type'));
        replace(LOGIN_URL);
      }
    },
    onError: () => {
      errorToast(t('sso-configuration-not-found'));
      replace(LOGIN_URL);
    },
  });


  const provider = useMemo(
    () =>
      // For now we only support SAML
      trust?.sso_provider_id
        ? new SAMLAuthProvider(trust?.sso_provider_id)
        : undefined,
    [trust],
  );

  const loginSAML = useCallback(() => {
    if (provider) {
      return loginWithProvider(provider);
    } else {
      // This should never happen
      errorToast('Misconfigured SSO login called');
    }
  }, [loginWithProvider, provider]);

  return {
    loginSAML,
    isLoading,
  };
};
